module.exports = __webpack_public_path__ + "img/img-yida-s3.1b27e83c.png";